import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { withTranslation, withFedopsLogger } from '@wix/yoshi-flow-editor';
import {
  getSelectedMethodId,
  isPendingPayment,
  isSuccessPayment,
} from '../../../../selectors/payment';
import styles from './payment-complete-page.scss';
import { FedopsInteractionsNames } from '../../../../constants/fedops-interaction-names';

const mapStateToProps = (state) => ({
  isPendingPayment: isPendingPayment(state),
  isSuccessPayment: isSuccessPayment(state),
  selectedMethodId: getSelectedMethodId(state),
});

class PaymentComplete extends React.Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    onCloseClick: PropTypes.func.isRequired,
    dealInfo: PropTypes.object,
  };

  componentDidMount() {
    this.props.fedops.interactionEnded(
      FedopsInteractionsNames.CASHIER_PAYMENT_COMPLETE_PAGE_LOAD,
    );
  }

  render() {
    const {
      isMobile,
      onCloseClick,
      dealInfo,
      isPendingPayment,
      isSuccessPayment,
      selectedMethodId,
    } = this.props;
    const { type, period } = dealInfo;

    const isPendingBuyer =
      isSuccessPayment && selectedMethodId === PaymentMethod.ConvenienceStore;
    const isPending = isPendingBuyer || isPendingPayment;
    const pendingMessage = isPendingBuyer
      ? 'widget.payments.video-pending-buyer'
      : 'widget.payments.video-will-be-available';

    return (
      <div
        data-hook="success-payment-page"
        className={classnames(styles.responsiveSuccessPayment, {
          [styles.mobile]: isMobile,
        })}
      >
        <div className={styles.info}>
          <div className={styles.subtitle}>
            {isMobile
              ? this.props.t(
                  'widget.payments.success-payment.thank-for-purchase-short',
                )
              : this.props.t(
                  'widget.payments.success-payment.thank-for-purchase',
                )}
          </div>
          <div
            className={classnames(styles.text, {
              [styles.pending]: isPending,
            })}
          >
            {isPending
              ? this.props.t(pendingMessage)
              : this.props.t(
                  `widget.payments.success-payment.video-is-available-${type}`,
                  { period },
                )}
          </div>
        </div>
        <button
          data-hook="success-payment-close-button"
          className={styles.close}
          aria-label={this.props.t('widget.payments.success-payment.close')}
          onClick={onCloseClick}
        >
          {this.props.t('widget.payments.success-payment.close')}
        </button>
      </div>
    );
  }
}

export default withFedopsLogger(
  withTranslation()(connect(mapStateToProps)(PaymentComplete)),
);
